import { MobiDocument } from './MobiDocument';
import { AllergieDocument } from './AllergieDocument';

export class IndividuAllergieDocument extends MobiDocument{
    private _id : string;
    private _rev : string;
    private id : number;
    private allergique_a : string;
    private allergie_id : number;
    private individu_id : number;



    public constructor(indAllergie:any) {
        super()
        this._id = indAllergie._id;
        this._rev = indAllergie._rev;
        this.id = indAllergie.id;
        this.allergique_a = indAllergie.allergique_a;
        this.allergie_id = indAllergie.allergie_id;
        this.individu_id = indAllergie.individu_id
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getAllergique_a(): string {
        return this.allergique_a;
    }

    public setAllergique_a(allergique_a: string): void {
        this.allergique_a = allergique_a;
    }

    public getAllergie_id(): number {
        return this.allergie_id;
    }

    public setAllergie_id(allergie_id: number): void {
        this.allergie_id = allergie_id;
    }

    public getIndividu_id(): number {
        return this.individu_id;
    }

    public setIndividu_id(individu_id: number): void {
        this.individu_id = individu_id;
    }

    public getAllergie() : AllergieDocument{
        let allergie : AllergieDocument = this.memdb.findOne({
            doctype: "AllergieDocument",
            fkey: "id",
            fvalue: this.allergie_id
        });
        allergie.setAllergiqueA(this.allergique_a);
        return allergie;
    }
}